var cell_default = {
  "cell": "n2WCE",
  "header": "-c9i4",
  "selected": "_4o2mZ",
  "editing": "j4DwB",
  "singleSelection": "z31EW",
  "hideLastBlock": "rLDYI",
  "editorWrapper": "lGhCq",
  "viewerWrapper": "AjDpb",
  "hideFirstBlock": "Qjfap",
  "editor": "FZEb6",
  "edit": "fHI39",
  "view": "y-A8S",
  "editingToolbarWrapper": "TbGge",
  "selectAll": "Ozlrl",
  "disableSelection": "SR2dn"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
